<template>
  <v-col sm="8" offset-sm="2" md="6" offset-md="3" lg="4" offset-lg="4">
    <v-card class="modern-login-card elevation-8">
      <v-card-text class="pa-8">
        <div class="logo">
          <img :src="logos.logoConstrate" class="logoImg" />
        </div>
        <login-form></login-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import LoginForm from "./Form";
import { mapGetters } from "vuex";

export default {
  components: {
    LoginForm,
  },
  computed: {
    ...mapGetters(["logos"]),
  },
  data() {
    return {
      logo: this.$store.state.logo,
    };
  },
};
</script>
<style lang="scss" scoped>
.modern-login-card {
  border-radius: 20px;
  background: white !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--corPrimaria, #1976d2);
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
  background: var(--corPrimaria);
  border-radius: 16px;
  padding: 24px 20px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--corPrimaria, #1976d2);
    border-radius: 16px;
    z-index: 0;
  }
}

.logoImg {
  max-width: 280px;
  width: 100%;
  height: auto;
  margin-top: 0;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  position: relative;
  z-index: 1;
}

// Responsividade
@media screen and (max-width: 768px) {
  .modern-login-card .v-card-text {
    padding: 24px 20px !important;
  }

  .logo {
    padding: 20px 16px;
    margin-bottom: 28px;
  }

  .logoImg {
    max-width: 220px;
  }
}

@media screen and (max-width: 480px) {
  .modern-login-card .v-card-text {
    padding: 20px 16px !important;
  }

  .logo {
    padding: 16px 12px;
    margin-bottom: 24px;
    border-radius: 12px;
  }

  .logoImg {
    max-width: 180px;
  }
}
</style>
